export const environment = {
  production: false,
  apiUrl: 'https://testapi.datronixcrm.net/api/v1',
  comuniApiUrl: 'https://axqvoqvbfjpaamphztgd.functions.supabase.co'
};

